<template>
    <div v-if="type == types.HEADING">
        <h2 v-if="!label">{{ 'HEADING' }}</h2>
        <h2 v-else>{{ label }}</h2>
    </div>
    <div v-else-if="type == types.SUB_HEADING">
        <h5 v-if="!label">{{ 'SUB HEADING' }}</h5>
        <h5 v-else>{{ label }}</h5>
    </div>
    <div v-else-if="type == types.STATIC_TEXT">
        <span v-if="!label">{{ 'FREE TEXT' }}</span>
        <span v-else>{{ label }}</span>
    </div>
</template>

<script>
export default {
    name: 'FreeInput',
    props: {
        type: {
            type: String,
        },
        types: {
            type: Object,
        },
        label: {
            type: String,
        },
    },
};
</script>
